// extracted by mini-css-extract-plugin
export default {"heroContainer":"hero_heroContainer__3PAl8","timeDiv":"hero_timeDiv__Jk2nG","imageDiv":"hero_imageDiv__XPAPq"};